import { Gift, Menu } from 'lucide-react'
import { HeaderTitle } from '../HeaderTitle'
import { useEffect, useMemo } from 'react'
import { useModal } from "@/hooks/useModal";
import { PromoBalanceModal } from '../Modals/PromoBalanceModal';
import { useBalance } from '@/hooks/useBalance';
import { centsToPrettyDollars } from '@skillscratch/shared-util';
import { ErrorModal } from '../Modals/ErrorModal';
// import { ReadyToScratchModal } from '../Modals/ReadyToScratchModal';
// import { TempPurchaseModal } from '../Modals/TempPurchaseModal';


export type HeaderProps = {
  sidebarOpen: boolean
  setSidebarOpen: (open: boolean) => void
};

export function Header({ sidebarOpen, setSidebarOpen }: HeaderProps) {
  const { openModal } = useModal();

  const [userData, isUserDataLoading, userDataError] = useBalance();


  const stringifiedBalance = useMemo(() => {
      return userData?.balance !== undefined ? centsToPrettyDollars(userData?.balance) : "$0.00";
  }, [userData?.balance]);

  const stringifiedPromoBalance = useMemo(() => {
      return userData?.promoBalance !== undefined ? centsToPrettyDollars(userData?.promoBalance) : "$0.00";
  }, [userData?.promoBalance])

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
      if (userDataError) {
          openModal(<ErrorModal message={userDataError.message}/>);
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDataError]);

  const handleBellClick = () => {
    openModal(<PromoBalanceModal />);
  }

  return (
    <>
      <header className="text-white w-full flex items-center justify-between">
        <button 
          type="button" 
          className="text-white -m-2.5 p-2.5 flex flex-row gap-2 items-center outline-none"
        >
          <span className="sr-only">Open sidebar</span>
          <Menu size={40} 
            onClick={() => setSidebarOpen(true)} 
          />
          <HeaderTitle />
        </button>
        

        
          <button 
            type="button"
            onClick={handleBellClick}
            className={`text-white p-2 focus:outline-none ${sidebarOpen ? 'opacity-15' : ''}`}
          >
            <div>
              <h1 className="text-lg font-bold tracking-tight">
                  {isUserDataLoading ? "$--.--" : stringifiedBalance}
              </h1>
              {
                  (userData?.promoBalance ?? 0) > 0 ? (
                      <span className='flex flex-row items-center gap-0.5 text-blue-dark font-medium text-sm opacity-80'>
                          <Gift size={16} />
                          <span>{stringifiedPromoBalance}</span>
                      </span>
                  ) : null
              }
            </div>
          </button>
      </header>

      <style>
        {`
          @keyframes ring {
            0% { transform: rotate(0); }
            10% { transform: rotate(20deg); }
            20% { transform: rotate(-15deg); }
            30% { transform: rotate(10deg); }
            40% { transform: rotate(-5deg); }
            50% { transform: rotate(0); }
            100% { transform: rotate(0); }
          }
        `}
      </style>
    </>
  )
}